import React, { useState } from 'react';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import './SmsOptInModal.css';

const SmsOptInModal = ({ user, onClose }) => {
  const [loading, setLoading] = useState(false);

  const handleOptIn = async (optIn) => {
    setLoading(true);
    try {
      // Determine which collection the user is in
      const collectionName = user.userType === 'volunteer' ? 'volunteers' : 'faculty_staff';
      const userRef = doc(db, collectionName, user.firestoreDocId || user.docId);
      
      await updateDoc(userRef, {
        smsOptIn: optIn,
        smsOptInDate: optIn ? serverTimestamp() : null,
      });
      
      console.log(`User ${optIn ? 'opted in' : 'opted out'} of SMS notifications`);
      
      // Reload the page to reflect the updated state
      setTimeout(() => {
        window.location.reload();
      }, 500);
      
    } catch (error) {
      console.error('Error updating SMS opt-in preference:', error);
      alert('Error saving preference. Please try again.');
      setLoading(false);
    }
    // Note: Don't call setLoading(false) here since we're reloading
  };

  return (
    <div className="sms-modal-overlay">
      <div className="sms-modal-content">
        <h2>📱 Enable Text Message Notifications?</h2>
        
        <p>Relief Roster can send you text messages for:</p>
        
        <ul className="sms-benefits-list">
          <li>New substitute teaching job opportunities</li>
          <li>Absence request confirmations</li>
          <li>Schedule changes and updates</li>
          <li>Important administrative notifications</li>
        </ul>
        
        <div className="sms-consent-box">
          <strong>By clicking "Yes", you consent to receive SMS messages from Relief Roster at the mobile number associated with your account.</strong>
        </div>
        
        <p className="sms-disclaimer">
          Standard message and data rates may apply. You can opt out at any time by replying STOP to any message or updating your preferences in account settings.
        </p>
        
        <div className="sms-button-group">
          <button 
            className="sms-btn sms-btn-primary" 
            onClick={() => handleOptIn(true)}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Yes, send me text messages'}
          </button>
          <button 
            className="sms-btn sms-btn-secondary" 
            onClick={() => handleOptIn(false)}
            disabled={loading}
          >
            No thanks
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmsOptInModal;